/**
 * TC Kimlik Numarası doğrulama fonksiyonu
 * @param {string|number} tckn - TC Kimlik Numarası
 * @returns {Object} { isValid: boolean, normalized?: string, formatted?: string }
 */
export const validateTCKN = (tckn) => {
    const tcknString = String(tckn || '').replace(/[^0-9]/g, '');

    if (!tcknString || tcknString.length !== 11) {
        return { isValid: false };
    }

    if (!/^\d{11}$/.test(tcknString)) {
        return { isValid: false };
    }

    const digits = tcknString.split('').map(d => parseInt(d, 10));

    // İlk rakam kontrolü
    if (digits[0] === 0) return { isValid: false };

    // Aynı rakam kontrolü
    if (new Set(digits).size === 1) return { isValid: false };

    // 10. hane algoritması
    const sumOdd = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
    const sumEven = digits[1] + digits[3] + digits[5] + digits[7];
    const tenthDigit = ((sumOdd * 7) - sumEven) % 10;
    const calculatedTenth = tenthDigit < 0 ? tenthDigit + 10 : tenthDigit;

    if (calculatedTenth !== digits[9]) return { isValid: false };

    // 11. hane algoritması
    const sumFirst10 = digits.slice(0, 10).reduce((sum, digit) => sum + digit, 0);
    const eleventhDigit = sumFirst10 % 10;

    if (eleventhDigit !== digits[10]) return { isValid: false };

    return {
        isValid: true,
        normalized: tcknString,
        formatted: tcknString.replace(/(\d{1})(\d{4})(\d{3})(\d{3})/, '$1 $2 $3 $4')
    };
};

